import Image from 'next/image'
import React from 'react'
import { useFocusMode } from '@/lib/hooks/helpers/useFocusMode'
import useGlobalStore from '@/store/useGlobalStore'
import { CartShareButton } from '../CartShareButton'

const CartSheetHeader = () => {
  const {
    user: { isSignedIn },
  } = useGlobalStore()

  const { isFocusMode, isLoadingIsFocusMode } = useFocusMode()

  return (
    <div className="border-b-2 border-slate-200 p-3">
      <div className="flex justify-between">
        <Image src="/icons/empty-cart.svg" height={24} width={24} alt="Cart" />
        {/* Hide share cart button when logged out in focus mode */}
        {!isLoadingIsFocusMode && (!isFocusMode || isSignedIn) && (
          <div className="flex space-x-2">
            <CartShareButton />
          </div>
        )}
      </div>
    </div>
  )
}

export default CartSheetHeader
